<template>
  <v-dialog v-model="show" scrollable persistent width="500" transition="dialog-bottom-transition">
    <v-card v-if="order!=null">
      <v-card-title>
        <strong>เลือกพนักงานส่งของ</strong>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 540px;">
        <v-list two-line v-if="drivers.length>0">
          <template v-for="(item, index) in drivers">
            <v-list-item :key="index" style="border-bottom:1px solid #efefef;">
              <v-list-item-content>
                <v-list-item-title>
                  <strong>{{item.user_info.firstname}} {{item.user_info.lastname}}</strong>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <div v-if="item.status=='available'" class="green lighten-1 badge-status">ว่างอยู่</div>
                  <div
                    v-else-if="item.status=='ongoing'"
                    class="orange lighten-2 badge-status"
                  >กำลังทำงาน</div>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  v-if="item.status=='available'"
                  outlined
                  small
                  color="primary"
                  ripple
                  @click="onSelectDriver(item)"
                >เลือก</v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
        <div class="text-center my-8" v-else>ยังไม่มีพนักงานส่งของ</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="white" depressed @click="close()">ปิด</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Service from "../services";
import { monthList } from "../utils/Constants";
import moment from "moment";

export default {
  name: "driver-dialog",
  props: {
    showDialog: { default: false },
    order: { default: null },
  },
  data() {
    return {
      loading: false,
      isPass: false,
      isError: false,
      form: null,
      drivers: [],
    };
  },
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  watch: {
    showDialog: function (newVal, oldVal) {
      // watch it
      if (newVal == true) {
        Service.Order.getDrivers(this.order.order_reference).then((res) => {
          this.drivers = res.data;
        });
      }
    },
  },
  methods: {
    onSelectDriver(item) {
      let data = {
        driver_type: "owned",
        driver_id: item.driver_id,
        driver: {
          scheduleAt: moment(this.order.datetime_received)
            .add(7, "hours")
            .toISOString(),
          serviceType: "MOTORCYCLE",
          specialRequests: ["LALABAG"],
          requesterContact: {
            name: "Halalize Co",
            phone: "0922499203",
          },
          stops: [],
          deliveries: [],
          paymentMethod: "CASH",
          sms: true,
          quotedTotalFee: {
            amount: null,
            currency: "THB",
          },
        },
        orders: [
          {
            order_id: this.order.order_id,
            order_reference: this.order.order_reference,
          },
        ],
      };

      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      Service.Delivery.requestClusterDriver(data).then((res) => {
        if (res.success) {
          this.loading = false;
          this.close();
        }
      });
    },
    close() {
      this.isError = false;
      this.$emit("close");
    },
  },
};
</script>